import { render, staticRenderFns } from "./PaintStyleOnEditingEditor.vue?vue&type=template&id=32c63d69&"
import script from "./PaintStyleOnEditingEditor.vue?vue&type=script&lang=ts&"
export * from "./PaintStyleOnEditingEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports